import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

/**
 * Meta carrying the exact node a `replaceNode` command located (stamped via the
 * `recordOriginalNode` action). `apply()` stores it on
 * `replaceNodeOriginalNode`, and `buildMountTransaction` reads it to rebuild an
 * accurate single-node `originalUserContentSlice` — the doc-range slice can
 * return a different shape (e.g. listItem children of a bulletList).
 */
export const AI_ORIGINAL_NODE_DATA = 'aiOriginalNodeData';

export interface AIOriginalNodeData {
	originalNode: PMNode;
}

/**
 * Meta on the terminal commit of a tool call force-finished by the queue timeout.
 * Set by `buildCommitTransaction` and consumed by `aiSessionContextPlugin.apply()`,
 * which records the final positions in `abortedToolCallPositions` for resume.
 */
export const CAPTURE_ABORTED_TOOL_CALL_POSITIONS = 'captureAbortedToolCallPositions';

export interface CaptureAbortedToolCallPositionsData {
	aiContentEndPos: number;
	startPos: number;
	toolCallId: string;
}
